import { ApiClient } from "../ApiClient";

const TRANSACTIONS_ENDPOINT = "finances/transactions";

export const getTransactions = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  // Removed the trailing slash before the '?' to match your working route
  const url = queryString
    ? `${TRANSACTIONS_ENDPOINT}?${queryString}`
    : TRANSACTIONS_ENDPOINT;

  const res = await ApiClient.get(url);
  return await res.json();
};

export const getTransactionDetails = async (transactionUuid) => {
  // Removed trailing slash here as well
  const res = await ApiClient.get(
    `${TRANSACTIONS_ENDPOINT}/${transactionUuid}`,
  );
  return await res.json();
};

export const updateTransaction = async (transactionUuid, data) => {
  const res = await ApiClient.put(
    `${TRANSACTIONS_ENDPOINT}/${transactionUuid}`,
    data,
  );
  return await res.json();
};
